import { useState } from 'react';
import { ExternalLink, Loader2 } from 'lucide-react';
import { useSession } from '../../lib/auth.js';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';

const planColors = {
  indie: 'var(--accent)',
  team: 'var(--success)',
  business: 'var(--warn)',
};

export default function Billing() {
  const { workspaces } = useSession();
  const ws = workspaces && workspaces[0];
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const plan = ws?.plan || 'indie';
  const status = ws?.status || 'unknown';

  const openPortal = async () => {
    if (!ws) return;
    setLoading(true);
    setError(null);
    try {
      const r = await fetch(`${API_BASE}/v1/billing/portal`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ workspace_id: ws.id }),
      });
      if (!r.ok) {
        const data = await r.json().catch(() => ({}));
        setError(data?.error?.message || `HTTP ${r.status}`);
        setLoading(false);
        return;
      }
      const data = await r.json();
      window.open(data.url, '_blank');
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  return (
    <div>
      <h1 style={title}>Billing</h1>

      <div style={card}>
        <div style={row}>
          <span style={label}>Plan</span>
          <span style={{ ...badge, background: planColors[plan] || 'var(--fg-3)', color: '#000' }}>
            {plan.charAt(0).toUpperCase() + plan.slice(1)}
          </span>
        </div>
        <div style={row}>
          <span style={label}>Status</span>
          <span style={value}>{status}</span>
        </div>
        <div style={row}>
          <span style={label}>Usage this period</span>
          <span style={value}>Metered  -  see Stripe portal</span>
        </div>
      </div>

      <button onClick={openPortal} disabled={loading} style={portalBtn}>
        {loading ? <Loader2 size={14} style={{ animation: 'spin 1s linear infinite' }} /> : <ExternalLink size={14} />}
        Open Customer Portal
      </button>

      {error && <p style={errText}>{error}</p>}
    </div>
  );
}

const title = { fontSize: 'var(--fs-22)', fontWeight: 600, color: 'var(--fg-0)', marginBottom: 'var(--space-5)' };
const card = { background: 'var(--bg-2)', border: '1px solid var(--line-1)', borderRadius: 'var(--r-2)', padding: 'var(--space-4)', marginBottom: 'var(--space-4)' };
const row = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 'var(--space-2) 0', borderBottom: '1px solid var(--line-1)' };
const label = { fontSize: 'var(--fs-13)', color: 'var(--fg-2)' };
const value = { fontSize: 'var(--fs-13)', color: 'var(--fg-0)' };
const badge = { padding: '2px 10px', borderRadius: 'var(--r-1)', fontSize: 'var(--fs-12)', fontWeight: 600 };
const portalBtn = { display: 'inline-flex', alignItems: 'center', gap: 'var(--space-1)', padding: 'var(--space-2) var(--space-4)', background: 'var(--accent)', color: 'var(--accent-fg)', border: 'none', borderRadius: 'var(--r-1)', fontSize: 'var(--fs-13)', fontWeight: 500, cursor: 'pointer' };
const errText = { color: 'var(--danger)', fontSize: 'var(--fs-13)', marginTop: 'var(--space-2)' };
